import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, ComponentFactoryResolver, Injector, AfterViewInit, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { CustomizeAciton } from './entities/customize-action.entity';
import { DatagridComponent } from '@farris/ui-datagrid';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { BsModalService, ModalOptions } from '@farris/ui-modal';
import { CustomizeActionListComponent } from './views/customize-action-list/customize-action-list.component';
import { TypeConverter } from '@farris/ide-property-panel';
import { MessagerService } from '@farris/ui-messager';
import { ActualParameter } from '../execute-forms/entities/execute-form.entity';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-customize-action',
  templateUrl: './customize-action.component.html',
  styleUrls: ['./customize-action.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class CustomizeActionComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input() editorParams: any = {};
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  modalConfig = {
    title: this.localePipe.transform('component.customizeAction.customizeAction'),
    width: 800,
    height: 520,
    showButtons: true
  };
  @Input() set value(data: any[]) {
    if (data && data.length > 0) {
      for (const d of data) {
        const action = new CustomizeAciton(d.id, d.code, d.name);
        action.terminalType = d.terminalType;
        action.actualParameters = [];
        if (d.actualParameters && d.actualParameters.length > 0) {
          for (const a of d.actualParameters) {
            const p = new ActualParameter();
            p.Name = a.Name;
            p.Value = a.Value;
            p.ValueText = a.ValueText;
            p.Tag = a.Tag;
            action.actualParameters.push(p);
          }
        }
        this.actions.push(action);
      }
    }
  }

  @ViewChild('actionlist') actionlist: DatagridComponent;
  @ViewChild('paramlist') paramlist: DatagridComponent;

  private terminalList = [
    { value: 'app', text: this.localePipe.transform('component.customizeAction.app') },
    { value: 'web', text: 'web' },
    { value: 'web,app', text: this.localePipe.transform('component.customizeAction.') }
  ];
  actions: CustomizeAciton[] = [];
  curAction: CustomizeAciton;
  columns = [
    { field: 'code', width: 100, title: this.localePipe.transform('component.customizeAction.code') },
    { field: 'name', width: 100, title: this.localePipe.transform('component.customizeAction.name') },
    {
      field: 'terminalType', width: 100, title: this.localePipe.transform('component.customizeAction.terminalType') ,
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: this.terminalList }
      },
    },
    // {
    //   field: 'enable', width: 100, title: '是否启用',
    //   editor: { type: EditorTypes.SWITCH, options: {} },
    //   formatter: { type: 'boolean', options: { trueText: '是', falseText: '否' } }
    // }
  ];
  paramColumns = [
    { field: 'Name', width: 50, title: this.localePipe.transform('component.customizeAction.paramName') },
    { field: 'ValueText', width: 50, title: this.localePipe.transform('component.customizeAction.valueText') },
    {
      field: 'Value', width: 100, title: this.localePipe.transform('component.customizeAction.value'),
      editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.showExprHelp(e);
          },
          clear: (e) => {
            console.log('clear', e);
          }
        }
      }
    }
  ];
  constructor(
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {

  }
  ngAfterViewInit() {
    this.loadData();
    // this.actionlist.loadData(this.actions);
    // if (this.actions && this.actions.length > 0) {
    //   this.actionlist.selectRow(this.actions[0].id, true);
    // }
  }
  addActions() {
    const compFactory = this.resolver.resolveComponentFactory(CustomizeActionListComponent);
    const compRef = compFactory.create(this.injector);
    const modalConfig: ModalOptions = {
      title: this.localePipe.transform('component.customizeAction.addActions'),
      width: 800,
      height: 520,
      showButtons: true,
      buttons: compRef.instance.footer
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.submit.subscribe((data: CustomizeAciton[]) => {
      if (data && data.length > 0) {
        for (const a of data) {
          const index = this.actions.findIndex(act => act.code === a.code);
          if (index > -1) {
            this.message.info(this.localePipe.transform('component.customizeAction.actionExisted'));
            this.actions.splice(index, 1);
          }
          this.actions.push(a);
        }
        this.loadData();
      }
      dialog.close();
    });
    compRef.instance.cancel.subscribe($event => dialog.close());
  }
  delete() {
    this.actionlist.endCellEdit();
    if (this.actionlist.selectedRow && this.actionlist.selectedRow.data) {
      const i = this.actions.findIndex(d => d.code === this.actionlist.selectedRow.data.code);
      this.actions.splice(i, 1);
      this.loadData();
      // this.actionlist.loadData(this.actions);
      // if (this.actions && this.actions.length > 0) {
      //   this.actionlist.selectRow(this.actions[0].id, true);
      // } else {
      //   this.curAction = null;
      // }
    } else {
      this.message.info(this.localePipe.transform('component.customizeAction.selectedRow'));
    }
  }

  clickOK() {
    this.actionlist.endCellEdit();
    this.paramlist && this.paramlist.endCellEdit();

    const object = { value: this.actions, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }
  loadData() {
    this.actionlist.loadData(this.actions);
    if (this.actions.length > 0 && (!this.actionlist.selectedRow || !this.actionlist.selectedRow.data)) {
      this.actionlist.selectRow(this.actions[0].id, true);
    } else {
      this.curAction = null;
    }
  }

  selectChanged(data: any) {
    this.curAction = data.data;
  }

  showExprHelp(e: any) {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    // if (e.instance.value) {
    this.expr.addExpressionText(e.instance.value);
    // }
    this.expr.buildExpression().then((expressioninfo: string) => {
      e.formControl.setValue(expressioninfo);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
}

export class CustomizeActionConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any[]): string {
    if (data && data.length > 0) {
      return this.localePipe.transform("component.customizeAction.set");
    } else {
      return this.localePipe.transform("component.customizeAction.notSet");
    }
  }
}
